import { render, staticRenderFns } from "./ImsTradersWidget.vue?vue&type=template&id=463a244d&"
import script from "./ImsTradersWidget.vue?vue&type=script&lang=js&"
export * from "./ImsTradersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports